/** @flow */

export const EMPLOYEE_REF_TYPES = {
  RECIPIENT: "recipient",
  TARGET: "target",
  MANAGER: "manager",
};
